import Recipe from "../../common/recipe"
import { useCallback, useEffect, useState } from "react"

import { useNavigate } from "react-router-dom"
import { getNews } from "../../api/getNews"
import { Button } from "antd-mobile"

function News() {
  const navigate = useNavigate()
  const [data, setData] = useState([])

  const onClick = useCallback(
    (id) => {
      navigate(`/recipeDetails?${id}`)
    },
    [navigate]
  )

  useEffect(() => {
    setData(getNews(0, 3))
  }, [])

  const onUpdate = useCallback(() => {
    setData([...data, ...getNews(data.length, 3)])
  }, [data])

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {data.map((item) => {
        return (
          <div key={item.id} onClick={() => onClick(item.id)}>
            <Recipe image={item.image} name={item.name} />
          </div>
        )
      })}
      <div style={{ paddingTop: 30, paddingBottom: 46 }}>
        <Button
          block
          color="success"
          fill="outline"
          size="large"
          onClick={onUpdate}
        >
          Загрузить ещё
        </Button>
      </div>
    </div>
  )
}

export default News
